import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon21: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 14.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 14 20" width={width} height={height} {...props}>
      <Path
        d="M13.5 0C13.7761 0 14 0.224 14 0.5V19.5C14 19.776 13.7761 20 13.5 20H0.5C0.22386 20 0 19.776 0 19.5V0.5C0 0.224 0.22386 0 0.5 0H13.5ZM13 1H1V19H13V1ZM6.9824 9.5C7.2585 9.5 7.4824 9.724 7.4824 10L7.483 10.371C7.6688 10.412 7.8529 10.469 8.0339 10.539C8.2553 10.626 8.4268 10.713 8.5323 10.777C8.7685 10.92 8.8441 11.228 8.7012 11.464C8.5582 11.7 8.2508 11.776 8.0145 11.633C7.9548 11.597 7.833 11.534 7.6702 11.471C7.4035 11.367 7.1336 11.305 6.8854 11.305C6.4099 11.305 6.1084 11.512 6.1084 11.744C6.1084 12.023 6.3683 12.214 7.2225 12.552L7.3113 12.587C8.5099 13.062 8.9684 13.386 8.9684 14.196C8.9684 15.025 8.3807 15.532 7.4834 15.669L7.4824 16.009C7.4824 16.285 7.2585 16.509 6.9824 16.509C6.7063 16.509 6.4824 16.285 6.4824 16.009L6.4818 15.674C6.1723 15.631 5.8971 15.547 5.6567 15.431C5.4253 15.319 5.2652 15.199 5.1715 15.102C4.97982 14.903 4.98553 14.587 5.1843 14.395C5.383 14.204 5.6996 14.209 5.8913 14.408C5.9064 14.424 5.9719 14.473 6.0911 14.53C6.3162 14.639 6.6049 14.706 6.9664 14.706C7.6635 14.706 7.9684 14.509 7.9684 14.196C7.9684 13.995 7.7355 13.831 6.9433 13.517L6.8543 13.482C5.6099 12.989 5.1084 12.622 5.1084 11.744C5.1084 10.989 5.7043 10.471 6.4823 10.339L6.4824 10C6.4824 9.724 6.7063 9.5 6.9824 9.5ZM10.5 7C10.7761 7 11 7.224 11 7.5C11 7.776 10.7761 8 10.5 8H3.5C3.22386 8 3 7.776 3 7.5C3 7.224 3.22386 7 3.5 7H10.5ZM10.5 4C10.7761 4 11 4.224 11 4.5C11 4.776 10.7761 5 10.5 5H3.5C3.22386 5 3 4.776 3 4.5C3 4.224 3.22386 4 3.5 4H10.5Z"
        fill="#73C177"
      />
    </Icon>
  )
}
